import type { Module } from 'vuex';
import type { DeferRootState, DeferCashierState } from '../constants';
import { actions as homePageActions } from './homepage-actions';

export function getPayDeferModule(): Module<DeferCashierState, DeferRootState> {
  return {
    namespaced: true,

    state: {},
    mutations: {},
    actions: {
      ...homePageActions,
    },
  };
}
